<template>
    <div class="table-navigation">
        <nav v-if="totalCount != null">
            <b-pagination
            :total-rows="parseInt(totalCount)"
            v-model="valueComp.currentPage"
            :per-page="valueComp.limit"></b-pagination>
        </nav>
        <nav v-if="hasNextPage != null">
            <pagination-small
            :hasNextPage="hasNextPage"
            v-model="valueComp.currentPage"></pagination-small>
        </nav>

        <div class="pagination-right">
            <b-btn class="button-tertiary button-tertiary-icon mr-2" v-on:click="reload"><img src="../../../assets/img/icon-refresh.svg"></b-btn>
            <label class="has-float-label-custom mr-2" v-if="showSearch">
                <input type="text" class="form-control search-grid" placeholder=" " v-model="valueComp.query" required />
                <img src="../../../assets/img/icon-color-cancel.svg" class="search-grid-clear" v-on:click="clear()">
                <span>{{$t('SEARCH')}}</span>
            </label>
            <label class="has-float-label-custom mr-4">
                <select class="form-control showing-items-dropdown" placeholder=" " v-model="valueComp.limit">
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                </select>
                <span>{{$t('ITEMSPERPAGE')}}</span>
            </label>
            <p v-if="totalCount != null">{{$t('SHOWING')}} {{paginValues.start}} - {{paginValues.end}} {{$t('FROM')}} {{totalCount}}</p>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Pagination',
    props: {
        totalCount: {
            type: Number,
            default: null,
        },
        hasNextPage: {
            type: Boolean,
            default: null,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Object,
            value: {
                currentPage: 1,
                limit: 25,
                sort: null,
                dir: 'asc',
            },
        },
    },
    methods: {
        reload()
        {
            const me = this;
            // eslint-disable-next-line prefer-object-spread
            me.valueComp = Object.assign({}, me.valueComp);

            me.$emit('reload');
        },
        clear()
        {
            const me = this;
            me.valueComp.query = '';
            me.valueComp = { ...me.valueComp };
        },
    },
    computed:
    {
        valueComp:
        {
            get()
            {
                const me = this;
                return me.value;
            },
            set(val)
            {
                const me = this;

                me.$emit('input', val);
            },
        },
        paginValues()
        {
            const me = this;
            return {
                start: (me.valueComp.currentPage - 1) * me.valueComp.limit,
                end: (me.valueComp.currentPage * me.valueComp.limit < me.totalCount)
                    ? me.valueComp.currentPage * me.valueComp.limit : me.totalCount,
            };
        },
    },
};
</script>